import { createFileRoute } from "@tanstack/react-router";
import AcceleratorOutline from "@/pages/AcceleratorOutline";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/accelerator/outline/")({
  component: () => (
    <RoleGate allow={['founder','staff','viewer']} area="Accelerator Outline"><AcceleratorOutline /></RoleGate>
  ),
});
